import { Storybook } from "@tento-ui/ui/storybook";
import { TurnTermBlock } from "./term-block";

export class TurnTermBlockStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · term-block";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Lisp — the highlighting the palette already defines",
        render: () =>
          TurnTermBlock.makeWith({
            language: "lisp",
            text: [
              '; Lazy agent lanes: advertised in the Shift-Tab cycle immediately.',
              '(lane.declare "opencode")',
              '(lane.declare "lead" :handler "deepseek" :permissions :allow-workspace)',
              '(@import "tento-claude" :as "claude" :from "/Users/james/.local/share/tento/tsh-apps")',
              '(prompt.use prompt.global)',
            ].join("\n"),
          }),
      },
      {
        title: "Plain — the default, because output is text until told otherwise",
        render: () =>
          TurnTermBlock.makeWith({
            text: [
              "perfile: emitted 162 modules, 1 roots → target.web.modules",
              "  @m/.../html/routes/index.root → /js/m/.../index.root.b796b9e0.js",
              "  skip routes/index.html (no bundled HTML)",
            ].join("\n"),
          }),
      },
      {
        title: "A single line",
        render: () =>
          TurnTermBlock.makeWith({ text: "cargo build -p tento-spool-server" }),
      },
      {
        title: "A long line scrolls inside the block, not the column",
        render: () =>
          TurnTermBlock.makeWith({
            language: "lisp",
            text:
              '(session.declare "spool-preview" :cwd "/Users/james/workspace/tento/tento-node-registry/tento-spool.node" :lanes ["ctl" "claude" "opencode"] :prompt prompt.global)',
          }),
      },
      {
        title: "Empty",
        render: () => TurnTermBlock.makeWith({ text: "" }),
      },
    ];
  }
}
